import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";
import {Map, Marker, NavigationControl, Popup} from 'maplibre-gl';

const API_KEY = '8d8bf301d9d530613f96f2c42b47551a';

function loadDataList(url) {
    const contentEl = document.querySelector('[data-listtype]');
    if (!contentEl) return;

    fetch(url)
        .then(r => r.text())
        .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContent = doc.querySelector('[data-listtype]');
            if (!newContent) return;

            contentEl.replaceWith(newContent);
            history.pushState(null, '', url);

            // Toggle-Button selected-State aktualisieren
            const isMap = newContent.dataset.listtype === 'map';
            const toggleBtns = document.querySelectorAll('.datalist_filter_togglemap_button');
            if (toggleBtns.length === 2) {
                toggleBtns[0].classList.toggle('selected', !isMap);
                toggleBtns[1].classList.toggle('selected', isMap);
            }

            // Toggle-Link href aktualisieren (enthält jetzt aktuelle Filter)
            const toggleLink = document.querySelector('.datalist_filter_togglemap');
            if (toggleLink) {
                const params = new URLSearchParams(location.search);
                if (isMap) params.delete('map'); else params.set('map', '1');
                toggleLink.href = location.pathname + (params.size ? '?' + params : '') + '#data-list';
            }

            // Reset-Link anzeigen/ausblenden/href aktualisieren
            const newReset = doc.querySelector('.datalist_filter_reset');
            const curReset = document.querySelector('.datalist_filter_reset');
            if (!newReset && curReset) {
                curReset.remove();
            } else if (newReset && !curReset) {
                document.querySelector('.datalist_filter_selects')?.appendChild(newReset);
            } else if (newReset && curReset) {
                curReset.href = newReset.href;
            }

            initMaps();
        });
}

function initFilter() {
    const filterForm = document.querySelector('.datalist_filter_selects form');
    if (!filterForm) return;

    const submitBtn = filterForm.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.style.display = 'none';

    const submitFilter = () => {
        const base = filterForm.action.split('#')[0];
        const params = new URLSearchParams(new FormData(filterForm));
        if (new URLSearchParams(location.search).has('map')) params.set('map', '1');
        loadDataList(base + (params.size ? '?' + params : ''));
    };

    filterForm.querySelectorAll('select, input[type="checkbox"], input[type="radio"]').forEach(input => {
        input.addEventListener('change', submitFilter);
    });

    let debounceTimer;
    filterForm.querySelectorAll('input[type="text"], input[type="search"]').forEach(input => {
        input.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(submitFilter, 400);
        });
    });
}

// Event-Delegation für Reset, Toggle und Pagination (überlebt DOM-Swaps)
document.addEventListener('click', e => {
    if (!document.querySelector('[data-listtype]')) return;

    const resetBtn = e.target.closest('.datalist_filter_reset');
    if (resetBtn) {
        e.preventDefault();
        const filterForm = document.querySelector('.datalist_filter_selects form');
        if (filterForm) {
            filterForm.querySelectorAll('select').forEach(s => s.selectedIndex = 0);
            filterForm.querySelectorAll('input[type="text"]').forEach(i => i.value = '');
            filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(i => i.checked = false);
        }
        loadDataList(resetBtn.href);
        return;
    }

    const toggleLink = e.target.closest('.datalist_filter_togglemap');
    if (toggleLink) { e.preventDefault(); loadDataList(toggleLink.href); return; }

    const pageLink = e.target.closest('.section_pagination a.page');
    if (pageLink) { e.preventDefault(); loadDataList(pageLink.href); }
});

function initMaps() {
    document.querySelectorAll('[data-behaviour="map"]').forEach(mapElement => {
        const center = mapElement.getAttribute('data-center');
        const map = new Map({
            container: mapElement,
            style: `https://www.goodmaps.de/map-styles/${API_KEY}`,
            center: center ? center.split(',') : [9.631947, 54.251622],
            zoom: 7,
            cooperativeGestures: true,
        });
        map.addControl(new NavigationControl());

        const dataElement = mapElement.querySelector('[data-behaviour="map-locations"]');
        const locations = JSON.parse(dataElement.textContent);

        locations.forEach(location => {
            const description = location.Description
                ? '<p class="map_marker_description">' + location.Description + '</p>'
                : '';

            const popup = new Popup({offset: 25});
            if (location.Link) {
                popup.setHTML(
                    `<h4 class="map_marker_title">${location.Title}</h4>` + description +
                    `<a class="map_marker_link link--button" href="${location.Link}">Mehr Informationen</a>`
                );
            } else {
                popup.setHTML(`<h4 class="map_marker_title">${location.Title}</h4>` + description);
            }

            new Marker()
                .setLngLat([location.Longitude, location.Latitude])
                .setPopup(popup)
                .addTo(map);
        });

        mapElement.querySelectorAll('[data-behaviour="map-jumper"]').forEach(mapjumper => {
            mapjumper.addEventListener('click', () => {
                map.jumpTo({
                    center: [mapjumper.getAttribute('data-longitude'), mapjumper.getAttribute('data-latitude')],
                    zoom: 15,
                });
            });
        });

        const maplisttoggle = mapElement.parentElement.querySelector('[data-behaviour="map-list-toggle"]');
        if (maplisttoggle) {
            maplisttoggle.addEventListener('click', () => {
                mapElement.parentNode.classList.toggle('show--list');
            });
        }
    });
}


document.addEventListener("DOMContentLoaded", function () {

    // ## Initialize MenuButton ##
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    });

    // ## Initialize Lightbox ##
    GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // ## Initialize Swiper ##
    document.querySelectorAll('.swiper').forEach(slider => {
        const autoSwiper = slider.classList.contains('swiper--auto');
        new Swiper(slider, {
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: { crossFade: true },
            direction: 'horizontal',
            loop: autoSwiper,
            autoplay: autoSwiper ? { delay: 5000 } : false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // ## Filter Auto-Submit (AJAX) ##
    initFilter();

    // ## Maps ##
    initMaps();

    // ## Backbutton ##
    document.querySelectorAll('[data-behaviour="backbutton"]').forEach(button => {
        button.addEventListener('click', () => window.history.back());
    });

    // ## Accordeon ##
    document.querySelectorAll('[data-behaviour="accordeon-item"]').forEach(item => {
        const accordeontitle = item.querySelector('.accordeon_item_title');
        const accordeonContent = item.querySelector('.accordeon_item_content');
        accordeonContent.style.maxHeight = '0px';

        accordeontitle.addEventListener('click', () => {
            item.classList.toggle('active');
            accordeonContent.style.maxHeight = item.classList.contains('active')
                ? accordeonContent.scrollHeight + 'px'
                : '0px';
        });
    });

    // ## District Selector ##
    const districtSelector = document.querySelector('[data-behaviour="district-selector"]');
    if (districtSelector) {
        districtSelector.addEventListener('change', () => {
            window.location.href = districtSelector.value;
        });
    }
});
